import React from "react";

export default function Footer() {
  return (
    <>
      <footer
        data-testid="footer-section"
        className="bg-emerald-deep text-cream relative overflow-hidden"
      >
      <div className="absolute inset-0 opacity-30 pointer-events-none"
           style={{
             backgroundImage:
               "radial-gradient(circle at 10% 20%, rgba(201,169,97,0.25), transparent 35%), radial-gradient(circle at 90% 80%, rgba(201,169,97,0.18), transparent 40%)",
           }}
      />
      <div className="relative max-w-5xl mx-auto px-6 py-20 text-center">
        <p className="text-[#E0C384] tracking-[0.45em] text-xs">VENDREDI</p>
        <h3 className="font-serif-display shimmer-text text-4xl md:text-5xl mt-3">
          14 Août 2026
        </h3>
        <p className="italic text-[#FAF6EC]/80 mt-2">Insha Allah · Bitam, Gabon</p>

        <div className="divider-ornament my-10">
          <span className="line" style={{ background: "linear-gradient(90deg, transparent, #C9A961, transparent)" }} />
          <span className="dot" style={{ borderColor: "#C9A961" }} />
          <span className="line" style={{ background: "linear-gradient(90deg, transparent, #C9A961, transparent)" }} />
        </div>

        <p className="font-script text-5xl md:text-6xl">Yero &amp; Maïmouna</p>
        <p className="font-serif-display italic mt-4 max-w-xl mx-auto text-[#FAF6EC]/80">
          « Et Il a mis entre vous de l’affection et de la bonté. »
        </p>

        <p className="mt-10 text-xs tracking-[0.35em] text-[#E0C384]/70">
          AVEC AMOUR · LES FAMILLES ALHADJI AMANE &amp; ALHADJI OUMAR
        </p>
      </div>
    </footer>
    </>
  );
}
